import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, reactive, unref, onMounted } from 'vue';

/* Npm Plugins */
import { ElMessage, FormRules, ElForm } from 'element-plus';

/* Plugins */
import { GbDialog } from '@/components/GbDialog/Index'

/* Utils & Hooks */
import { GetCategoryApi, CategoryCreateApi, CategoryModifyApi, GetParentListApi } from '../../../apis/ct_categorys/category.api';
import { CtCategoryBase } from '../../../apis/ct_categorys/category.dto';


export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit: $emits }) {



const state = reactive({
    show: false,
    loading: false,
    isEdit: false,
})

const formRules = reactive<FormRules>({
    code: [{ required: true, message: '分类标识不能为空', trigger: 'blur' },],
    name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' },],
    parent_id: [{ required: true, message: '请选择上级分类', trigger: 'blur' },],
})

const elFormRef = ref<ComponentRef<typeof ElForm>>()

const formSchema = ref<CtCategoryBase>({
    id: '',
    revision: '',
    parent_id: '',
    name: '',
    is_enabled: '',
    sort: 1000,
    level: 2,
    code: '',
    remark: '',
})

const parentList = ref<any[]>([])

const load = {
    /* 获取分类详细 */
    getCategoryInfo: async (rowId: string) => {

        state.loading = true

        const { succeeded, errors, data } = await GetCategoryApi(rowId)

        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            formSchema.value = Object.assign(data)
        }

        state.isEdit = true
        state.loading = false
    },

    getParentList: async () => {
        const { succeeded, errors, data } = await GetParentListApi()

        if (!succeeded)
            ElMessage.error(errors)
        else {
            parentList.value = data
        }
    }
}

const exposeFuncs = {

    /* 新建 */
    create: (perId: string) => {
        formSchema.value = Object.assign({
            id: '',
            revision: '0',
            parent_id: perId,
            code: '',
            name: '',
            is_enabled: 'Y',
            sort: 1000,
            level: 2,
            remark: '',
        })

        state.isEdit = false
        state.loading = false
        state.show = true
    },

    /* 编辑 */
    modify: async (rowId: string) => {
        await load.getCategoryInfo(rowId)

        state.isEdit = true
        state.show = true
    },
}

/* 点击保存按钮 */
const onSaveBtnClick = () => {

    unref(elFormRef)?.validate(async (isValid: boolean) => {

        if (!isValid) return;

        const data = unref(formSchema)
        state.loading = true;


        const Apis = state.isEdit ? CategoryModifyApi : CategoryCreateApi
        const { succeeded, errors } = await Apis(data)

        state.loading = false

        if (!succeeded) {
            ElMessage.error(errors)
        }
        else {
            ElMessage.success("保存成功")

            state.show = false
            $emits('success')
        }
    })
}

expose({ ...exposeFuncs })

onMounted(async () => {
    await load.getParentList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).isEdit ? '编辑分类' : '创建分类',
    style: {"width":"640px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _unref(state).loading,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: formSchema.value,
          "label-width": "120px",
          "label-position": 'right',
          rules: _unref(formRules)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    (formSchema.value.parent_id != '10000000-0000-0000-0000-000000000001')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "上级分类",
                          prop: "parent_id"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formSchema.value.parent_id,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.parent_id) = $event)),
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parentList.value, (dic) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: dic.name,
                                    value: dic.id
                                  }, null, 8, ["label", "value"]))
                                }), 256))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "分类标识",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.code,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.code) = $event)),
                          type: "text",
                          placeholder: "请输入模块标识"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "分类名称",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.name) = $event)),
                          type: "text",
                          placeholder: "请输入模块名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.remark) = $event)),
                          rows: "4",
                          placeholder: "备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.sort) = $event)),
                          step: "100",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "启用状态",
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})